'use strict';
const angular = require('angular');
const _ = require('lodash');
import * as moment from 'moment';
import { Ids as ACTION_IDS } from '../../components/constants/action.constants'
import { Api_Ids as API_CONNECTION } from '../../components/constants/api.connection.constants'

export class MainController {

  Util: any;
  $document: any;
  $uibModal: any;
  selectedView: any;
  store: any;
  filter: any;
  $scope: any;
  arrayHierarchy: any;
  ngNotification: any;
  selectedStep: any;
  showAddConnectionForm: boolean;
  externalApi: any;
  controlDataFieldNames: any;
  showTestResult: any;
  connectionLists: any;
  operatoFieldrArray: any;
  conjuctionFieldArray: any;
  listFilters: any;
  externalApiMethods: any;
  externapAPIData: any;
  $http: any;
  params: any;
  USP;
  // showSpinner: boolean;
  $httpParamSerializer: any;
  apiConnectionClosed: any;
  baseUrl: any;
  currentProject: String;
  currentProjectId: any;


  constructor(localStorage, $scope, $http, $stateParams, $httpParamSerializer, Notification, $uibModal, $document, Util, $window, $rootScope, config, PROJECTNAME) {

    let self = this;
    this.Util = Util;
    this.$scope = $scope;
    this.$document = $document;
    this.$uibModal = $uibModal;
    this.store = localStorage;
    this.ngNotification = Notification;
    this.USP = $rootScope.USP;
    this.$http = $http;
    this.params = $stateParams.params;
    this.$httpParamSerializer = $httpParamSerializer;
    // this.showSpinner = false;
    this.connectionLists = [];
    this.showAddConnectionForm = false;
    this.baseUrl = config.baseUrl;
    this.currentProject = PROJECTNAME.replaceAll("&#39;", "'");
    this.currentProjectId = config.formDetail ? config.formDetail.id.projectId: "";
  }

  IsCustomData(controlFields, item) {
    return controlFields.find(el => el.value === item.value);
  }

  openAPIConfigurationDialog() {
    let self = this;
    let apiConfigurationModalInstance = self.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      // template: '<apiconnection  dismiss="$ctrl.cancel()"></apiconnection>',
      templateUrl: 'apiConnections.html',
      backdrop: 'static',
      keyboard: false,
      controllerAs: '$apictrl',
      windowClass: 'api-connection-modal',
      appendTo: angular.element(self.$document[0].querySelector('.canvas')),
      controller: ['$scope', 'Notification', "$window", "config", function ($scope, Notification, $window, config) {

        angular.element(window).on('resize', () => {
          this.apiEditorResizeHandler();
        });

        window.setTimeout(() => {
          this.apiEditorResizeHandler();
        }, 10);

        document.body.style.overflow = 'hidden';
        this.apiEditorResizeHandler = function () {
          let width = Math.min(1280, window.innerWidth);
          let height = Math.min(600, window.innerHeight);
          let margin = (width <= 768) ? 10 : 30;
          angular.element('.api-connection-modal .modal-dialog').css({
            'width': (width - (margin * 2)) + 'px',
            'height': (height - (margin * 2)) + 'px',
            'marginTop': margin + 'px',
            'marginBottom': margin + 'px'
          });
        }

        this.setDataType = function (item) {
          item.dataType = 'custom';
        }
        this.userSearchApiId = API_CONNECTION.USER_SEARCH_API_ID;
        this.config = config;
        this.$scope = $scope;
        this.selectedStep = 1;
        this.showAddConnectionForm = false;
        this.isTestConnection = false;
        this.externalApi = false;
        this.showTestResult = false;
        var fieldNames = [];
        this.controlDataFieldNames = self.Util.getDataFieldNames();
        this.apiData = [];
        this.optionalFields = [];
        this.showSpinner = false;
        this.isDuplicate = false;
        this.specialCharacter = false;
        this.ngNotification = Notification;
        this.$window = $window;
        this.objParam = {
          name: '',
          externalApi: false,
          apiId: '',
          description: '',
          bodyParamsType: '',
          status: 'Not Connected'
        }
        this.fetchUsersTypeId = [
          {
            key : 'Project Distribution',
            value: 1
          },
          {
            key : 'Project Organisations',
            value: 2
          },
          {
            key : 'Project Roles',
            value: 3
          },
          {
            key : 'User Email Address',
            value: 4
          }
        ];
        this.formSearchIsActive = [
          {
            key : 'Active',
            value: 'Active'
          },
          {
            key : 'Inactive',
            value: 'Inactive'
          },
          {
            key : 'All',
            value: 'All'
          }
        ];
        this.multiValueParameters = [];
        this.connectionLists = [
        ]
        this.operatoFieldrArray = [{
          key: '==',
          value: '=='
        },
        {
          key: '!=',
          value: '!='
        },
        {
          key: 'IN',
          value: 'IN'
        },
        {
          key: 'NOT IN',
          value: 'NOT IN'
        }];
        this.parameters = [];
        this.externalApiMethods = [{
          key: 'GET',
          value: 'GET'
        },
        {
          key: 'POST',
          value: 'POST'
        }];

        this.externapAPIData = {
          params: [],
          headers: [],
          bodyParams: []
        };
        this.projects = [];
        this.selectedProjects = [];
        this.selectedProjectIds = [];
        this.selectedFormsTypesId = [];
        this.formTypes = [];
        this.customFormFields = [];
        this.customAttrOptions = [];
        this.optionalFieldsCopy = [];
        this.formStatuses = [];
        this.selectedStatuses = [];
        this.currentProjectSelected = false;
        this.removeConnectionObject = {};
        this.regex = /^[^`~!@#$%\^&*={}|[\]\\:';"<>?,./]*$/;

        this.getApiconnectionLists = function () {
          this.selectedStep = 1;
          this.showSpinner = true;
          this.showTestResult = false;
          this.isTestConnection = false;
          this.testResults = [];
          this.externapAPIData = angular.copy({
            params: [],
            headers: [],
            bodyParams: []
          });
          let instanceGroupId = self.params.id.instanceGroupId || null;
          let projectId = self.params.id.projectId || null;
          let formId = self.params.id || null;
          let queryParams = '';
          if (instanceGroupId && projectId) {
            queryParams = '?instanceGroupId=' + instanceGroupId + '&projectId=' + projectId;
          } else {
            queryParams = '?formId=' + formId;
          }

          self.$http({
            'url': (<any>window).properties.service.uri + ACTION_IDS.GET_API_CONNECTION_LIST + queryParams,
            'method': 'GET',
            'withCredentials': true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },

          }).then(response => {
            this.connectionLists = response.data.entity;
            this.showSpinner = false;
          }, response => {
            this.ngNotification.error({ message: 'Error while getting api connection data', positionX: 'center', replaceMessage: true });
            this.showSpinner = false;
          });
        }

        this.getAsiteSupportedAPi = function () {
          this.showSpinner = true;
          self.$http({
            'url': (<any>window).properties.service.uri + ACTION_IDS.GET_ALL_FORMS,
            'method': 'GET',
            'data': {},
            'withCredentials': true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },

          }).then(response => {
            this.apiData = response.data;
            this.showSpinner = false;
          }, response => {
            this.ngNotification.error({ message: 'Error while getting AsiteSupportedAPi data', positionX: 'center', replaceMessage: true });
            this.showSpinner = false;
          });

        }

        this.getAllProjectes = function () {
          this.showSpinner = true;
          self.$http({
            'url': (<any>window).properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + ACTION_IDS.GET_ALL_PROJECTS,
            'method': 'POST',
            data: self.$httpParamSerializer({ action_id: 1001, recordBatchSize: -1 }),
            'withCredentials': true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }

          }).then(response => {
            // console.log("response", response);
            let projects = [];
            if (response.data.totalDocs > 0) {
              projects = response.data.data;
            } else {
              projects = [];
            }
            this.projects = projects.map((item) => {
              item.isSelected = false;
              return item;
            });
            this.projects.unshift({ value: '{{Current Project}}', id: 0, isSelected: false });
            this.projects.splice(this.projects.findIndex(el => el.value === 'Project Templates'), 1);
            this.showSpinner = false;
          }, response => {
            this.showSpinner = false;
            this.ngNotification.error({ message: 'Error while getting projects data', positionX: 'center', replaceMessage: true });
          });

        }

        this.getFormsTypesId = function (projectIds) {
          this.showSpinner = true;
          self.$http({
            'url': (<any>window).properties.service.commonApiUrl + ACTION_IDS.GET_FORMSTYPEBYPROJECTS + '?projectIds=' + projectIds,
            'method': 'POST',
            'withCredentials': true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(response => {
            // console.log("response", response);
            this.formTypes = response.data;
            this.showSpinner = false;

            var formTypeValue = this.parameters.find(e => e.name == 'FormName' && e.value != "");
            if (formTypeValue && formTypeValue.value) {
              var exists = this.formTypes.find(e => e.formTypeName == formTypeValue.value);
              if (!exists) {
                var params = angular.copy(this.parameters);
                params = params.map((item) => {
                  if (item.name == 'FormName') {
                    item.value = '';
                  }
                  return item;
                });
                this.parameters = angular.copy(params);
              }
            }
            if (formTypeValue && formTypeValue.value) {
              let customFormFormTypeId = response.data.filter((item) => {
                return item.formTypeName == formTypeValue.value;
              });
              if (customFormFormTypeId.length > 0) {
                let selectedProjectId = customFormFormTypeId[0].hashedProjectId;
                customFormFormTypeId = customFormFormTypeId[0].formTypeID.split("$$")[0];
                this.getCustomFormFieldsWithFormTypeIds(selectedProjectId, customFormFormTypeId);
              } else {
                  this.onChangeFormType(this.parameters);
              }
            }
            
          }, response => {
            this.ngNotification.error({ message: 'Error while getting formTypes data', positionX: 'center', replaceMessage: true });
            this.showSpinner = false;
          });
        }

        this.getCustomFormFieldsWithFormTypeIds = function (selectedProjectIds, selectedFormsTypesId) {
          this.showSpinner = true;
          self.$http({
            'url': (<any>window).properties.service.commonApiUrl + ACTION_IDS.GET_CUSTOMFORMFIELDS + '?projectId=' + selectedProjectIds + '&formTypeIds='+selectedFormsTypesId,
            'method': 'GET',
            'withCredentials': true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(response => {
            this.showSpinner = false;
            let responseData = response.data;
            if (responseData) {
              // filter for controls not to show in the custom fields.
              responseData = responseData.filter(function(x) {
                return x.type != 'SiteLocationButton' && x.type != 'Button' && x.type != 'Section' && x.type != 'Layout' && x.type != 'Table' && x.type != 'RepeatingTable' && x.type != 'Attachment' && x.type != 'Rating' && x.type != 'ToggleButton' && x.type != 'InlineAssocFiles' && x.type != 'InlineAssocApps' && x.type != 'ViewAssociations'
              });
              this.customFormFields = responseData.map(function (val) {
                let obj = {
                  name: "",
                  displayFieldName: "",
                  dataType: "",
                  operator: "",
                  value: null,
                  testValue: null,
                  conjunction: null,
                  hidden: false,
                  mandatory: false,
                  header: false,
                  encrypted: false,
                  isDataSelected: false,
                };
                obj.name = val.fieldXPath;
                obj.displayFieldName = val.formFieldName;
                return obj;
              });

              // Filter the controls like Layout, Table, Repeating Table controls [ controls which does not havre the name property]
              this.customFormFields = this.customFormFields.filter(function(x) {
                return x.name;
              });

              if (this.optionalFieldsCopy.length == 0) {
                this.optionalFieldsCopy = angular.copy(this.optionalFields);
              }
              
              this.optionalFields = [
                ...this.optionalFieldsCopy,
                ...this.customFormFields,
              ];
            }

          }, response => {
            this.ngNotification.error({ message: 'Error while getting CustomFormFields data', positionX: 'center', replaceMessage: true });
            this.showSpinner = false;
          });
        }

        this.getFormsStatuses = function (projectIds, formTypeId) {
          this.showSpinner = true;
          self.$http({
            'url': (<any>window).properties.service.commonApiUrl + ACTION_IDS.GET_FORMSTATUS_BY_PROJECTS + '?projectIds=' + projectIds,
            'method': 'POST',
            'withCredentials': true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(response => {
            // console.log("response", response);
            if (response.data && response.data.length > 0) {
              let statusList = response.data.map(function (item, i) {
                return {
                  id: i,
                  value: item
                };
              });
              this.formStatuses = angular.copy(statusList);
              this.showSpinner = false;
            }
          }, response => {
            this.ngNotification.error({ message: 'Error while getting formStatus data', positionX: 'center', replaceMessage: true });
            this.showSpinner = false;
          });
        }

        this.getAsiteSupportedAPi();
        this.getApiconnectionLists();

        this.getAllProjectes();


        this.changeAsiteApi = function () {
          this.parameters = [];
        }

        this.addConnection = function () {
          this.objParam = {
            name: '',
            externalApi: false,
            apiId: '',
            description: '',
            bodyParamsType: '',
            status: 'Not Connected'
          };
          this.externapAPIData = angular.copy({
            params: [],
            headers: [],
            bodyParams: []
          });
          this.showAddConnectionForm = true;
          this.selectedStep = 1;
          this.testResults = [];
          this.parameters = [];
          this.currentProjectSelected = false;
          this.testFilters = [];
          this.isDuplicate = false;
          this.specialCharacter = false;
          this.isTestConnection = false;
        }



        this.save = function () {
          this.showSpinner = true;
          let data = angular.copy(this.objParam);
          data.instanceGroupId = self.params.id.instanceGroupId || null;
          data.projectId = self.params.id.projectId || null;
          data.formId = (!self.params.id.projectId && !self.params.id.instanceGroupId) ? self.params.id : null;
          if (data && data.externalApi) {
            data.parameters = angular.copy(this.externapAPIData);
            this.externapAPIData = angular.copy(this.testFilters);
            let controlDataFieldNames = this.controlDataFieldNames;
            // check for the headers data if key has value or not if value check if valu is custom type or text
            let headersArray = angular.copy(this.externapAPIData.headers);
            headersArray = this.externapAPIData.headers.filter(el => el['name'] != '');

            let newHeadersArray = headersArray.map((item) => {
              const a = self.IsCustomData(controlDataFieldNames, item);
              if (a) item.dataType = 'custom';
              else item.dataType = 'text';
              return item;
            });

            // check for the params data if key has value or not if value check if valu is custom type or text
            let paramsArray = angular.copy(this.externapAPIData.params);
            paramsArray = this.externapAPIData.params.filter(el => el['name'] != '');
            let newParamssArray = paramsArray.map((item) => {
              const a = self.IsCustomData(controlDataFieldNames, item);
              if (a) item.dataType = 'custom';
              else item.dataType = 'text';
              return item;
            });

            // check for the BodyParams data if key has value or not if value check if valu is custom type or text
            let bodyParamsArray = angular.copy(this.externapAPIData.bodyParams);
            bodyParamsArray = this.externapAPIData.bodyParams.filter(el => el['name'] != '');
            let newBodyParamsArray = bodyParamsArray.map((item) => {
              const a = self.IsCustomData(controlDataFieldNames, item);
              if (a) item.dataType = 'custom';
              else item.dataType = 'text';
              return item;
            });

            data.parameters.headers = newHeadersArray;
            data.parameters.params = newParamssArray;
            data.parameters.bodyParams = newBodyParamsArray
            data.testUrl = this.testFilters.testUrl;
          } else {

            let param = angular.copy(this.testFilters);

            let controlDataFieldNames = this.controlDataFieldNames;
            param = param.map(function (item) {
              if (item.name == 'ProjectName' || item.name == 'FormStatus') {
                delete item.searchText;
                delete item.isOpen;
                delete item.isLimited;
                delete item.isLimited;
                delete item.selectedValues;
              }
              const a = self.IsCustomData(controlDataFieldNames, item);
              if (a) item.dataType = 'custom';
              else item.dataType = 'text';
              item.asiteApiId = parseInt(item.asiteApiId);
              if(item.multiValue){
                item.multiValue = null;
              }
              return item;
            })
            data.parameters = angular.copy(param);

            let selectedAsiteApiId = this.objParam.asiteApiId;
            let selectedApi = this.apiData.find(function (item) {
              return item.asiteApiId == selectedAsiteApiId;
            });
            data.url = selectedApi.url;
            data.requestType = selectedApi.requestType;
          }
          if(this.objParam.hasOwnProperty('apiId') && this.objParam.apiId!=''){
            data.hasOldDelimiter = data.hasOldDelimiter ? data.hasOldDelimiter : true;
          }else {
            data.hasOldDelimiter = false;
          }

          let queryString = '';
          if (data.instanceGroupId && data.projectId) {
            queryString = '?instanceGroupId=' + data.instanceGroupId + '&projectId=' + data.projectId;
          } else {
            queryString = '?formId=' + data.formId;
          }
          // console.log("savedd data", data);
          delete data.instanceGroupId;
          delete data.projectId;
          delete data.formId;

          self.$http({
            'url': (<any>window).properties.service.uri + ACTION_IDS.SAVE_API_CONNECTION + queryString,
            'method': "POST",
            data: self.$httpParamSerializer({ "apiData": data }),
            'withCredentials': true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(response => {
            this.showSpinner = false;
            if (response.data.httpCode == 200 && response.data.message == 'SUCCESS') {
              // console.log("saving data", response);
              this.getApiconnectionLists();
              this.showAddConnectionForm = false;
            } else {
              this.ngNotification.error({ message: response.data.message, positionX: 'center', replaceMessage: true });
            }

          }, err => {
            // console.log("errro saving data", err);
            this.showSpinner = false;
          });
          // making the optional fields isDataSelected to false at time of save. its making issue at time of add connection 
          for (let m = 0; m < this.optionalFields.length; m++) {
            if(this.optionalFields[m].isDataSelected){
              this.optionalFields[m].isDataSelected = false;
            }            
          }
        };

        this.isParamtersValid = function () {
          let mandatoryParam = this.parameters.filter(obj => obj.mandatory && !obj.hidden);
          return mandatoryParam.filter(function (obj) {
            return obj.value ? false : true;
          });
        };
        this.check = function (name) {
          // var reg = /^[^`~!@#$%\^&*()_+={}|[\]\\:';"<>?,./]*$/;
          var reg = /^[^`~!@#$%\^&*={}|\\:';"<>?,./]*$/;
          if (name && !name.match(reg)) {
            this.specialCharacter = true;
          } else {
            this.specialCharacter = false;
          }
          this.isDuplicate = false;
        }

        this.isAlreadyExists = function (name, id) {
          const isExists = this.connectionLists.some(function (obj) {
            return obj.name == name && obj.apiId != id;
          });

          if (isExists) {
            this.isDuplicate = true;
          } else {
            this.isDuplicate = false;
          }
        };

        this.next = function () {
          // add scroll to auto
          var modalElement = $('.api-connection-modal');
          modalElement[0].style.overflowY = "auto";

          if (this.selectedStep == 1) {
            let isExists = this.isAlreadyExists(this.objParam);
            if (isExists || this.specialCharacter) {
              this.ngNotification.error({ message: 'This form contains validation errors or mandatory fields are not specified. Please filled in and try again.', positionX: 'center', replaceMessage: true });
              return false;
            }
          }

          if (this.selectedStep == 2 && !this.objParam.externalApi) {
            let valid = this.isParamtersValid().length == 0;
            if (!valid) {
              this.ngNotification.error({ message: 'This form contains validation errors or mandatory fields are not specified. Please filled in and try again.', positionX: 'center', replaceMessage: true });
              return false;
            }
          }

          this.selectedStep = this.selectedStep + 1;
          if (this.selectedStep === 2) {
            if (this.objParam.externalApi && (this.objParam.apiId || this.objParam.isCopyData)) {
              this.externapAPIData = angular.copy(this.objParam.parameters);
            }

            if (!this.objParam.externalApi) {
              let selectedApi = this.objParam.asiteApiId;
              let filterData = this.apiData.filter(function (item) {
                return item.asiteApiId == selectedApi;
              });
              let param = filterData[0].parameters.map(function (el) {
                if (el.name == 'ProjectName' || el.name == 'FormStatus') {
                  el.selectedValues = [];
                }
                delete el.paramId;
                return el;
              })
              let requiredFields = param.filter(function (item) {
                return item.mandatory == true;
              });
              this.optionalFields = param.filter(function (item) {
                return item.mandatory == false && item.hidden === false;
              });
              
              // filter the param which having the multiValue property.
              let multiValueData = filterData[0].parameters.filter(function (item) {
                return item.mandatory == false && item.multiValue;
              });

              let isOldDelimiter = this.objParam.hasOwnProperty('hasOldDelimiter') && this.objParam.hasOldDelimiter ? true : false; 

              // param multiValue property string to object.
              this.multiValueParameters = multiValueData.reduce((acc, curr) => {
                acc[curr.name] = curr.multiValue.split('#').reduce((acc, curr) => {
                  const [key, value] = curr.split(':');
                  acc.push({
                    key,
                    value,
                  });
                  return acc;
                }, []);
                return acc;
              }, {});

              if(this.objParam.apiId){
                this.optionalFields = [...this.optionalFields, ...this.customFormFields];
              }   

              if (this.parameters.length > 0) {
                let parameters = angular.copy(this.parameters);
                requiredFields.forEach(function (data) {
                  let index = parameters.findIndex(x => x.name == data.name);
                  if (index === -1) {
                    parameters.push(data);
                  }
                });
                this.parameters = parameters;
              } else {
                this.parameters = angular.copy(requiredFields);
              }
              this.parameters = this.parameters.map(function (item) {
                var object = item;
                if (object.name == 'ProjectName' || object.name == 'FormStatus') {
                  if (object.value && object.value != "") {
                    if(isOldDelimiter)
                      object.selectedValues = item.value.split(',');
                    else
                      object.selectedValues = item.value.split('###');
                  } else {
                    object.selectedValues = [];
                  }
                }
                object.operator = object.operator ? object.operator : '==';
                return object;
              });
              const mandatoryFalse = this.parameters.filter((obj)=>{
                return obj.mandatory == false;
              });
              if(mandatoryFalse){
                for (let j = 0; j < this.optionalFields.length; j++) {
                    for (let i = 0; i < mandatoryFalse.length; i++) {
                      if(this.optionalFields[j].name == mandatoryFalse[i].name){
                        this.optionalFields[j].isDataSelected = true;
                        break;
                      }
                      else this.optionalFields[j].isDataSelected = false;
                  }
                }
              }
              if (selectedApi == API_CONNECTION.FORM_SEARCH_API_ID) {
                this.parameters = _.orderBy(this.parameters, 'name', 'desc');
                this.parameters = _.orderBy(this.parameters, 'mandatory', 'desc');
              }
            }

            if (this.objParam.externalApi) {
              // add data in array if no object in the array
              if (this.externapAPIData.headers.length == 0) this.externapAPIData.headers.push({ name: '', value: '' });
              if (this.externapAPIData.params.length == 0) this.externapAPIData.params.push({ name: '', value: '' });
              if (this.externapAPIData.bodyParams.length == 0) this.externapAPIData.bodyParams.push({ name: '', value: '' });
            }

          }
          if (this.selectedStep == 3) {
            // do test result data blank
            this.testResults = [];
            this.showTestResult = false;
            if (!this.objParam.externalApi) {
              this.testFilters = angular.copy(this.parameters);
              this.testFilters = this.testFilters.filter(el => el.name != "");
              this.testFilters = this.testFilters.map((item) => {
                item.testValue = item.value && self.IsCustomData(this.controlDataFieldNames, item) ? '' : item.value;
                return item;
              });

            }
            else {
              this.testFilters = angular.copy(this.externapAPIData);
              this.testFilters.testUrl = this.objParam.url;
              this.testFilters.params = this.testFilters.params.map((item) => {
                item.testValue = item.value && self.IsCustomData(this.controlDataFieldNames, item) ? '' : item.value;
                return item;
              }).filter((data) => {
                return data.name != '';
              });
              this.testFilters.headers = this.testFilters.headers.map((item) => {
                item.testValue = item.value && self.IsCustomData(this.controlDataFieldNames, item) ? '' : item.value;
                return item;
              }).filter((data) => {
                return data.name != '';
              });;
              this.testFilters.bodyParams = this.testFilters.bodyParams.map((item) => {
                item.testValue = item.value && self.IsCustomData(this.controlDataFieldNames, item) ? '' : item.value;
                return item;
              }).filter((data) => {
                return data.name != '';
              });
            }
          }
        }
        this.back = function () {
          this.selectedStep = this.selectedStep - 1;
          var modalElement = $('.api-connection-modal');
          modalElement[0].style.overflowY = "auto";
        }
        this.stepClickHandler = function (clickedStep) {
          // this.selectedStep = clickedStep;
        }

        this.changeAPI = function () {
          this.objParam.externalApi = !this.objParam.externalApi;
          if (this.objParam.externalApi) {
            this.parameters = [];
          } else {
            this.externapAPIData = {
              params: [],
              headers: [],
              bodyParams: []
            };
          }
        }
        this.onToggle = function () {

          if (this.objParam.apiId || this.parameters.length > 0 || (this.externapAPIData.headers.length > 0 || this.externapAPIData.params.length > 0 || this.externapAPIData.bodyParams.length > 0)) {
            this.ngNotification.warning({
              message: 'Filter and Response section might have field added as per the selection, would you like to change', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_changeData.html", scope: this.$scope
            });
          } else {
            this.objParam.externalApi = !this.objParam.externalApi;
          }
        }
        this.addNewFilter = function (listFilters, $event) {
          var index = Object.keys(this.parameters).length;
          this.parameters.push({
            name: '',
            operator: '',
            value: '',
            conjuction: ''
          });
        };
        this.removeFilter = function (filter) {
          var index = this.parameters.indexOf(filter);
          const filteredData = this.optionalFields.find(function (response) {
            return response.displayFieldName === filter.displayFieldName;
          });
          if (filteredData) {
            filteredData.isDataSelected = false;
          }
          if (index >= 0)
            this.parameters.splice(index, 1);
        };
        this.addNewMapping = function ($event) {
          var index = Object.keys(this.listMappings).length;
          this.listMappings.push({
            sourceData: '',
            mapto: '',
          });
        };
        this.removeMapping = function (item) {
          var index = this.listMappings.indexOf(item);
          if (index >= 0)
            this.listMappings.splice(index, 1);
        };
        this.testConnection = function (data) {
          this.showTestResult = false;
          this.showAddConnectionForm = true;
          this.isTestConnection = true;
          this.testResults = [];
          this.selectedStep = 2;
          this.objParam = data;
          if (data.externalApi) {
            this.externapAPIData = angular.copy(data.parameters)
          } else {
            this.parameters = angular.copy(data.parameters);
            let selectedApi = data.asiteApiId;
            let filterData = this.apiData.filter(function (item) {
                return item.asiteApiId == selectedApi;
            });

            // filter the param which having the multiValue property.
          let multiValueData = filterData[0].parameters.filter(function (item) {
            return item.mandatory == false && item.multiValue;
          });

          // param multiValue property string to object.
          this.multiValueParameters = multiValueData.reduce((acc, curr) => {
            acc[curr.name] = curr.multiValue.split('#').reduce((acc, curr) => {
              const [key, value] = curr.split(':');
              acc.push({
                key,
                value,
              });
              return acc;
            }, []);
            return acc;
          }, {});
          }

          
          this.next();
        }

        this.testRun = function () {
          this.isTestConnection = false;
          let configData = this.config;
          let myHeaders = {};
          let queryString = '';
          if (this.objParam.externalApi) {
            let parameters = angular.copy(this.testFilters);
            parameters.params = parameters.params.map(function (item) {
              item.value = item.testValue;
              return item;
            });

            parameters.headers = parameters.headers.map(function (item) {
              item.value = item.testValue;
              return item;
            });

            parameters.bodyParams = parameters.bodyParams.map(function (item) {
              item.value = item.testValue;
              return item;
            });


            let datas = Object.assign({}, this.objParam);
            datas.parameters = angular.copy(parameters);
            datas.url = datas.parameters.testUrl;
            delete datas.parameters.testUrl;
            let url = (<any>window).properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'apps?action_id=858&externalApi=true';
            let req = {
              'url': url,
              'method': 'POST',
              'withCredentials': true,
              data: JSON.stringify(datas),

            };

            this.showSpinner = true;
            self.$http(req).then(response => {
              this.testResults = response.data;
              this.showSpinner = false;
              this.showTestResult = true;
              if(response.data && response.data.status != 'fail'){
                this.objParam.status = 'Established';
              } else {
                this.objParam.status = 'Failed';
                this.ngNotification.error({ message: 'Test Run failed', positionX: 'center', replaceMessage: true });
              }
            }, error => {
              // console.log("err", error);
              this.showSpinner = false;
              this.showTestResult = true;
              this.objParam.status = 'Failed';
              this.ngNotification.error({ message: 'Test Run failed', positionX: 'center', replaceMessage: true });
            });

          } else {
            let selectedAsiteApiId = this.objParam.asiteApiId;
            let selectedApi = this.apiData.find(function (item) {
              return item.asiteApiId == selectedAsiteApiId;
            });
            let queryString = '';

            let headers = this.testFilters.filter(el => el.header == true);

            headers = headers.reduce(function (prev, curr) {
              if (curr.name !== '') {
                prev[curr.name] = self.USP.aSessionId || '';
                return prev;
              }
            }, {});

            let data = this.testFilters.filter(el => el.header == false);
            let operatorObject = {};

            // create object for the operator fiedname
            operatorObject = data.reduce(function (prev, curr) {
              if (curr.name != "isComingFormApiConnection") {
                if (curr.operator == 'IN')
                  prev["operator_" + curr.name] = "CONTAINS";
                else if (curr.operator == 'NOT IN')
                  prev["operator_" + curr.name] = "NOT_CONTAIN";
                else if (curr.operator == '!=')
                  prev["operator_" + curr.name] = "NOT_EQUALS";
                else
                  prev["operator_" + curr.name] = "EQUALS";
              }
              return prev;
            }, {});

            // create a object for the key value for pair from the array
            let queryObject = {};
            queryObject = data.reduce(function (prev, curr) {
              if (curr.name !== '') {
                if(curr.name == 'projectId'){
                  prev[curr.name] = configData.formID.projectId;
                }else if(curr.name == 'formTypeId'){
                  prev[curr.name] = configData.formID.formTypeId;
                }else if(curr.name == 'ProjectName'){
                  prev[curr.name] = curr.testValue.replaceAll("{{Current Project}}",self.currentProject);
                }else
                prev[curr.name] = curr.testValue;
                return prev;
              }
            }, {});

            // create a query string from the obect to pass it to the api as queryparam
            const finalQueryObject = Object.assign({}, queryObject, operatorObject);
            if (finalQueryObject) {
              queryString = Object.keys(finalQueryObject)
                .map(name => `${encodeURIComponent(name)}=${encodeURIComponent(finalQueryObject[name])}`)
                .join('&');
            }
            this.objParam.url = selectedApi.url;
            this.objParam.requestType = selectedApi.requestType;
            let baseUrl = self.baseUrl;

            // send hasOldDelimiter in app api call
            let isOldDelimiter = true;
            if(this.objParam.hasOwnProperty('hasOldDelimiter')){
              isOldDelimiter = this.objParam.hasOldDelimiter;
            }
            if(!this.objParam.apiId)
              isOldDelimiter = false;

            let internalAPiUrl = (<any>window).properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'apps?action_id=858&hasOldDelimiter='+isOldDelimiter;
            queryString = queryString + '&externalApi=false&apiUrl=' + this.objParam.url;
            let req = {
              'url': queryString == '' ? internalAPiUrl : internalAPiUrl + '&' + queryString,
              'method': this.objParam.requestType,
              'withCredentials': true,
              'headers': (headers && Object.keys(headers).length === 0) ? {} : headers,
            }
            this.showSpinner = true;
            self.$http(req).then(response => {
              this.testResults = response.data;
              this.showSpinner = false;
              this.showTestResult = true;
              if(response.data && response.data.status != 'fail'){
                this.objParam.status = 'Established';
              } else {
                this.objParam.status = 'Failed';
                this.ngNotification.error({ message: 'Test Run failed', positionX: 'center', replaceMessage: true });
              }
              
            }, error => {

              this.showSpinner = false;
              this.showTestResult = true;
              this.objParam.status = 'Failed';
              this.ngNotification.error({ message: 'Test Run failed', positionX: 'center', replaceMessage: true });
            });
          }
        }
        this.editConnection = function (item) {
          this.selectedStep = 1;
          this.objParam = angular.copy(item);
          this.showAddConnectionForm = true;
          this.testResults = [];
          this.isDuplicate = false;
          this.specialCharacter = false;
          this.isTestConnection = false;
          this.parameters = angular.copy(this.objParam.parameters);
          if (!this.objParam.externalApi && item.asiteApiId == API_CONNECTION.FORM_SEARCH_API_ID) {
            this.objParam.asiteApiId = parseInt(this.objParam.asiteApiId);
            let selectedValues = this.parameters.find(el => el.name === 'ProjectName').value;
            let projectArray = (this.objParam.hasOwnProperty('hasOldDelimiter') && this.objParam.hasOldDelimiter == true) ? selectedValues && selectedValues.split(',') : selectedValues && selectedValues.split('###');
            if (projectArray.length > 0 && (!projectArray.includes('{{Current Project}}') || self.currentProject)) {
              let selectedProjects = [];
              let selectedProjectNames = [];
              let projects = this.projects;
              projectArray.forEach(function (element) {
                let selectElement = element;
                let val = projects.find(el => el.value == selectElement);
                if (val){ 
                  selectedProjects.push(val.id);
                  selectedProjectNames.push(val.value);
                }
              });
              selectedProjects.forEach(function(part, index, theArray) {
                if(theArray[index] == "0"){
                    theArray[index] = self.currentProjectId;
                }
              });
              let projectIds = selectedProjects.join(',');

              // remove the projects from params if not available in projectlist
              
              let isOldDelimiter = this.objParam.hasOwnProperty('hasOldDelimiter') && this.objParam.hasOldDelimiter == true ? true : false;
              this.parameters = this.parameters.map(function (item) {
                // delete item.id;
                if(item.name == "ProjectName"){
                  if(isOldDelimiter)
                    item.value =  selectedProjectNames.join(',');
                  else 
                    item.value =  selectedProjectNames.join('###');
                }
                return item;
              });
	            // End remove the projects from params if not available in projectlist

              this.getFormsTypesId(projectIds); 
              this.getFormsStatuses(projectIds, ''); 
            } else {
              this.currentProjectSelected = true;
            }
          }

        }

        this.copy = function (item) {
          let copyData = angular.copy(item);
          copyData.name = '';
          delete copyData.apiId;
          copyData.status = "Not Connected";
          copyData.isCopyData = true;
          if (copyData.externalApi) {
            let params = angular.copy(copyData.parameters.params);
            params = params.map(function (item) {
              delete item.id;
              return item;
            });

            let headers = angular.copy(copyData.parameters.headers);
            headers = headers.map(function (item) {
              delete item.id;
              return item;
            });

            let bodyParams = angular.copy(copyData.parameters.bodyParams)
            bodyParams = bodyParams.map(function (item) {
              delete item.id;
              return item;
            });
            copyData.parameters.params = angular.copy(params);
            copyData.parameters.headers = angular.copy(headers);
            copyData.parameters.bodyParams = angular.copy(bodyParams);
          } else {
            let parameters = angular.copy(copyData.parameters);
            parameters = parameters.map(function (item) {
              delete item.paramId;
              return item;
            });
            copyData.parameters = angular.copy(parameters);
          }
          this.editConnection(copyData);
        }
        this.removeConnection = function () {
          const item = angular.copy(this.removeConnectionObject);
          self.$http({
            'url': (<any>window).properties.service.uri + ACTION_IDS.REMOVE_API_CONNECTION + '?apiId=' + item.apiId,
            'method': "POST",
            'withCredentials': true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(response => {
            // console.log("remove data", response);
            this.showSpinner = false;
            this.getApiconnectionLists();
            this.showAddConnectionForm = false;
          }, err => {
            // console.log("errro copy data", err);
            this.ngNotification.error({ message: 'Error while removing api connection data', positionX: 'center', replaceMessage: true });
            this.showSpinner = false;
          });
        }

        this.remove = function (item) {

          this.removeConnectionObject = item;
          this.ngNotification.warning({
            message: 'Please confirm if you wish to remove the API connection?', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_remove_connection.html", scope: this.$scope
          });
        }

        this.addNewParams = function ($event) {
          var index = Object.keys(this.externapAPIData.params).length;
          this.externapAPIData.params.push({
            name: '',
            value: '',
          });
        };
        this.removeParams = function (item) {
          var index = this.externapAPIData.params.indexOf(item);
          if (index >= 0)
            this.externapAPIData.params.splice(index, 1);
        };

        this.addNewHeaders = function ($event) {
          var index = Object.keys(this.externapAPIData.headers).length;
          this.externapAPIData.headers.push({
            name: '',
            value: '',
          });
        };

        this.removeHeaders = function (item) {
          var index = this.externapAPIData.headers.indexOf(item);
          if (index >= 0)
            this.externapAPIData.headers.splice(index, 1);
        };

        this.addNewBodyParams = function ($event) {
          var index = Object.keys(this.externapAPIData.bodyParams).length;
          this.externapAPIData.bodyParams.push({
            name: '',
            value: '',
          });
        };

        this.removeBodyParams = function (item) {
          var index = this.externapAPIData.bodyParams.indexOf(item);
          if (index >= 0)
            this.externapAPIData.bodyParams.splice(index, 1);
        };

        /**
         * @brief      Close dialog
         * @return     NULL
         */

        this.dismiss = function () {
          // apiConfigurationModalInstance.dismiss('cancel');
          apiConfigurationModalInstance.close(false);
          self.apiConnectionClosed()
        }
        this.cancel = function () {

          this.ngNotification.warning({
            message: 'There is some unsaved data, would you like to cancel it?', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_cancel.html", scope: this.$scope
          });
        };

        this.initialDropdownPosition = function (item) {
          //calculate position for multidropdown display if at the end of the screen / or not sufficient space

          var minHeight = 78, pos;
          var listLen = item.name == 'ProjectName' ? (this.projects).length : (this.formStatuses).length;
          var curDropdownHeight = minHeight + (28 * listLen);
          curDropdownHeight = curDropdownHeight > 347 ? 359 : curDropdownHeight;
          var windowHeight = $(window).innerHeight();
          var pageScroll = $('.modal-dialog').scrollTop();
          var curElement = angular.element('div[data-name=' + item.name + ']');
          var offset = curElement.offset();
          var toppos = offset.top;
          var space = windowHeight - (offset.top - pageScroll);
          // if (space < curDropdownHeight) {
          //   pos = (toppos - curDropdownHeight) + 'px';
          // } else {
          //   pos = (toppos + 34) + 'px';
          // }
          pos = (toppos + 34) + 'px';
          var dropdownMenuElem = angular.element('div[data-name=dd_' + item.name + ']');
          dropdownMenuElem[0].style.top = pos;
          var modalElement = $('.api-connection-modal');
          // make scroll hidden when multi dropdown open
          if (item.isOpen) {
            modalElement[0].style.overflowY = "hidden";
          } else {
            modalElement[0].style.overflowY = "auto";
          }
        }

        this.onMultiDropdownToggle = function (item, $event,) {
          let selectionArr = [],
            nonSelectedArr = [];
          item.isLimited = false;
          let options = [];
          if (item.name == 'ProjectName')
            options = this.projects;
          else if (item.name == 'FormStatus')
            options = this.formStatuses;

          if (item.isOpen) {
            item.searchText = '';
            for (var i = 0; i < options.length; i++) {
              if ((item.selectedValues).includes(options[i].value)) {
                options[i].isSelected = true;
              } else {
                options[i].isSelected = false;
              }
            }
            for (var y = 0; y < options.length; y++) {
              if (options[y].isSelected) {
                selectionArr.push(options[y]);
              } else {
                nonSelectedArr.push(options[y]);
              }
            }
            if (item.name == 'ProjectName')
              this.projects = selectionArr.concat(nonSelectedArr);
            else if (item.name == 'FormStatus')
              this.formStatuses = selectionArr.concat(nonSelectedArr);
          }
          this.initialDropdownPosition(item);
        }

        this.onChangeFormType = function (data) {
          if (data) {
            this.parameters = this.parameters.filter((el) => {
              return el.mandatory == true;
            });

            let formNameData = data.filter((item) => {
              return item.name == "FormName";
            });
            // projectIdData = projectIdData[0].value.split(",");
            let projectId;
            // for (let i = 0; i < projectIdData.length; i++) {
            //   projectId = this.projects.filter((item) => {
            //     return item.value === projectIdData[i];
            //   });
            // }

            
            // if(projectId.length > 0){
            //   projectId = projectId[0].id;
            // }

            let formTypeID = this.formTypes.filter((item) => {
              return item.formTypeName === formNameData[0].value;
            });

            if (formTypeID && formTypeID.length > 0) {
              projectId = formTypeID[0].hashedProjectId;
            }

            if (formTypeID && formTypeID.length > 0) {
              formTypeID = formTypeID[0].formTypeID.split("$$")[0];
            }

            if (projectId && formTypeID && formTypeID.length > 0) {
              this.getCustomFormFieldsWithFormTypeIds(projectId, formTypeID);
            }
            // Filter the optionalFields if the form name not selected / select the please select in form name.
            if(formTypeID.length === 0 || formTypeID && formTypeID.length > 0) {
              this.optionalFields = this.optionalFields.filter(item => !this.customFormFields.includes(item));
            }
          }
        };

        this.clearMultiDropdownSearch = function (item) {
          //clear search value
          item.searchText = '';
          item.isLimited = false;
          // this.initialDropdownPosition(item);
        }
        this.clearMultiDropdown = function (item) {
          // to pass in setMultiDDSelection function parameter.
          let selectedItem = {
            'isSelected': true
          };
          //clear selection
          item.selectedValues = [];
          item.value = "";
          if (item.name === 'ProjectName') {
            for (var i = 0; i < this.projects.length; i++) {
              this.projects[i].isSelected = false;
            }
          } else if (item.name === 'FormStatus') {
            for (var i = 0; i < this.formStatuses.length; i++) {
              this.formStatuses[i].isSelected = false;
            }
          }
          // call the function to clear the option selected in Form Name and other below fields on click of "clear" button in Project Name value dropdown.
          this.setMultiDDSelection(item,selectedItem);
        }
        this.closeMultiDropdown = function (item) {
          item.isOpen = false;
          item.isLimited = false;
          var modalElement = $('.api-connection-modal');
          // make scroll hidden when multi dropdown open
          modalElement[0].style.overflowY = "auto";

        }

        this.showAll = function (item) {
          item.isLimited = true;

          //calculate position for multidropdown display if at the end of the screen / or not sufficient space
          var minHeight = 78, pos;
          var listLen = item.name == 'ProjectName' ? (this.projects).length : (this.formStatuses).length;
          var curDropdownHeight = minHeight + (28 * listLen);
          curDropdownHeight = curDropdownHeight > 347 ? 359 : curDropdownHeight;
          var windowHeight = $(window).innerHeight();
          var pageScroll = $('.modal-dialog').scrollTop();
          var curElement = angular.element('div[data-name=' + item.name + ']');
          var offset = curElement.offset();
          var toppos = offset.top;
          var space = windowHeight - (offset.top - pageScroll);
          // if (space < curDropdownHeight) {
          //   pos = (toppos - curDropdownHeight) + 'px';
          // } else {
          //   pos = (toppos + 34) + 'px';
          // }
          pos = (toppos + 34) + 'px';
          var dropdownMenuElem = angular.element('div[data-name=dd_' + item.name + ']');
          dropdownMenuElem[0].style.top = pos;
        }


        this.setMultiDDSelection = function (item, selectedItem) {
          selectedItem['isSelected'] = selectedItem.isSelected == undefined ? true : !selectedItem.isSelected;
          if (selectedItem.isSelected) {
            item.selectedValues.push(selectedItem.value)
            if(this.objParam.hasOwnProperty('hasOldDelimiter') && this.objParam.hasOldDelimiter){
              item.value = item.selectedValues.map((item) => { return item }).join(',');
            }else 
              item.value = item.selectedValues.map((item) => { return item }).join('###');
          } else {
            for (var i = 0; i < item.selectedValues.length; i++) {
              var sitem = item.selectedValues[i];
              if (selectedItem.value == sitem) {
                item.selectedValues.splice(i, 1);
                break;
              }
            }
            if(this.objParam.hasOwnProperty('hasOldDelimiter') && this.objParam.hasOldDelimiter){
              item.value = item.selectedValues.map((item) => { return item }).join(',');
            }else 
              item.value = item.selectedValues.map((item) => { return item }).join('###');
          }
          // call getfromType and formStatus api based on selected projects
          if (item.selectedValues.length > 0 && item.name === 'ProjectName') {
            let projectIds = this.projects.filter(res => res.isSelected).map(ele => ele.id).join(',');
            if (item.selectedValues.includes('{{Current Project}}')  && !self.currentProject ) {
              this.currentProjectSelected = true;
            } else {
              this.currentProjectSelected = false;
              if (projectIds) {
                let selecteProj = projectIds.split(",");
                selecteProj.forEach(function(part, index, theArray) {
                  if(theArray[index] == "0"){
                      theArray[index] = self.currentProjectId;
                  }
                })
                
                selecteProj = selecteProj.join(",");
                this.getFormsTypesId(selecteProj);
                this.getFormsStatuses(selecteProj, "");
              }
            }
          } else if (item.selectedValues.length == 0) {
            // empty the Form Name option on change of Project Name
            this.formTypes = [];
            this.onChangeFormType(this.parameters);
          }
        }
        this.multiSelectToggled = function (item) {
          var modalElement = $('.api-connection-modal');
          // make scroll hidden when multi dropdown open
          if (item.isOpen) {
            modalElement[0].style.overflowY = "hidden";
          } else {
            modalElement[0].style.overflowY = "auto";
          }
        }
        this.onChangeFieldValue = function (item, param, index) {
          const filteredData = this.optionalFields.find(function (response) {
            return response.name === item;
          });
          if (filteredData) {
            this.parameters[index] = angular.copy(filteredData);
            this.parameters[index].operator = '==';
            delete this.parameters[index].paramId;
          }
          const mandatoryFalse = this.parameters.filter((obj)=>{
            return obj.mandatory == false;
          });
          if(mandatoryFalse){
            for (let j = 0; j < this.optionalFields.length; j++) {
                for (let i = 0; i < mandatoryFalse.length; i++) {
                  if(this.optionalFields[j].name == mandatoryFalse[i].name){
                    this.optionalFields[j].isDataSelected = true;
                    break;
                  }
                  else this.optionalFields[j].isDataSelected = false;
              }
            }
          }  
          filteredData.isDataSelected = true;
        }
        this.openHelpPage = function () {
          this.$window.open((<any>window).properties.service.helpUrl);
        }

        this.showDatepicker = function ($event) {
          var myElem = angular.element($event.currentTarget.previousElementSibling);
          if (myElem.length > 0) {
            myElem.datetimepicker('show');
          }
        }
        this.getDatePickerOptions = function (properties) {
          return this.datePickerOptions;
        }
        this.timePickerOptions = {
          showMeridian: true,
        };

        this.getParsedDate = function (param) {
          let dateTimeFormat = self.Util.getNewDateFormat('default');
          let itemVal = param.value;
          itemVal = moment(itemVal, dateTimeFormat).toDate();
          if (itemVal == 'Invalid Date') {
            param.value = '';
          }
        }
        this.datePickerOptions = {
          format: self.Util.getNewDateFormat('default'),
          showClear: true,
          showClose: true,
          showTodayButton: true,
          sideBySide: true,
          keepOpen: false,
          useCurrent: false,
          toolbarPlacement: "bottom",
          locale: window.navigator.language.split('_')[0],
          icons: {
            close: 'closeText',
            clear: 'clearText',
            today: 'todayText'
          }
        };

        this.addAppendUrlValue = function (selectedVal) {
          if (angular.isObject(selectedVal)) {
            const appendValue = '{{' + selectedVal.value + '}}';
            this.objParam.url = this.objParam.url ? this.objParam.url + appendValue : appendValue;

          } else {
            const appendValue = selectedVal;
            this.objParam.url = this.objParam.url ? this.objParam.url + appendValue : appendValue;
          }
          this.appendUrlValue = '';
        };
        this.isEmpty = function (obj) {
          return Object.keys(obj).length == 0;
        }

      }]
    });
  }
}
export default angular.module('directives.apiconnection', [])
  .component('apiconnection', {
    template: require('./api-connection.html'),
    controller: MainController,
    bindings: {
      apiConnectionClosed: '&apiConnectionClosed'
    }
  })
  .name;


// WEBPACK FOOTER //
// ./client/components/api-connection/api-connection.component.ts